import type {
    ActiveRoleAssignmentOperationalResponse,
    ActiveRoleAssignmentResponse,
} from '@pillar-portal/api-types';

export function getActiveRoleAssignmentOperationalResponse(
    activeRoleAssignmentResponse: ActiveRoleAssignmentResponse | null | undefined
): ActiveRoleAssignmentOperationalResponse | null {
    return activeRoleAssignmentResponse?.activation_state === 'operational'
        ? activeRoleAssignmentResponse
        : null;
}
